import React from "react";
import { useDispatch } from "react-redux";

import { fetchDiscovered } from "../../../../../../../store/devices/discovered";
import { RefreshButton } from "../../../../../../../components/table/components";

export const OnlineDevicesInfo = () => {
  const dispatch = useDispatch();

  return <RefreshButton onClick={() => dispatch(fetchDiscovered())} />;
};
